import {Component, OnInit, Inject, OnDestroy} from '@angular/core';
import { Router } from '@angular/router';
import {DOCUMENT} from "@angular/common";
import {RequestService} from "../../core/services/request/request.service";
import { UserService } from 'src/app/core/services/user/user.service';
import { UtilService } from 'src/app/core/services/util/util.service';
import {InternationalizationService} from "../../core/services/internationalization/internationalization.service";
import {Subscription} from "rxjs";

@Component({
  selector: 'sb-catalog-page',
  templateUrl: './catalog-page.component.html',
  styleUrls: ['./catalog-page.component.scss']
})
export class CatalogPageComponent implements OnInit, OnDestroy {

  localeChanged$: Subscription;

  constructor(private router: Router,
              @Inject(DOCUMENT) private document: HTMLDocument,
              private requestService: RequestService,
              private userService: UserService,
              private utilService: UtilService,
              private i18nService: InternationalizationService,) {
  }

  ngOnInit() {
    // Wipe out the page context
    (window as any).KO_PAGE_CONTEXT.clear();

    // Wipe out the Knockout content.
    const pageContentMain = document.getElementById("page-content-main");
    if (pageContentMain) {
      pageContentMain.innerHTML = "";
    }

    // Mark as catalog page
    document.getElementById("detailMain")?.classList?.add("sb-catalog-page-content");

    this.localeChanged$ = this.i18nService.localeChanged$.subscribe(async (_) => {
      // Now done in the locale selector component
      // window.location.reload();
    });
  }

  ngOnDestroy() {
    document.getElementById("detailMain")?.classList?.remove("sb-catalog-page-content");

    this.localeChanged$ && this.localeChanged$.unsubscribe();
  }
}
